import React, { useState, useEffect } from 'react';
import { Modal } from 'semantic-ui-react';

const OpenModuleDialog = function(props) {

  const [ txt, setTxt ] = useState('');

  let foo = React.createRef();

  const changeFile = (e, d) => {
    const reader = new FileReader();
    reader.onload = function(evt) {
      setTxt(evt.target.result);
    }
    reader.readAsText(foo.current.files[0]);
  }

  useEffect(() => setTxt(''), [props.visible]);


  return (
    <Modal className='open-module' open={props.visible} onClose={props.onClose}>
      <Modal.Header>Open module</Modal.Header>
      <Modal.Content>
        <input type='file' name='file' onChange={changeFile} ref={foo} />
        <pre>{txt}</pre>
      </Modal.Content>
    </Modal>
  );
}


export default OpenModuleDialog;
